export default "__VITE_ASSET__Ecoyt0Tg__"